import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

/**
 * Shows a confirm modal with brand color support
 * @param {function} onOk 
 * @param {string} primaryColor 
 */
const ShowConfirmClose = (onOk, primaryColor = '#faa200') => {
  Modal.confirm({
    title: 'Are you sure you want to continue?',
    content: 'All unsaved changes will be lost.',
    icon: <ExclamationCircleFilled style={{ color: primaryColor }} />,
    autoFocusButton: null,
    okText: 'Continue',
    cancelText: 'Cancel',
    cancelButtonProps: {
      style: {
        color: primaryColor,
        backgroundColor: 'white',
        borderColor: primaryColor,
      },
    },
    okButtonProps: {
      style: { color: 'white', backgroundColor: primaryColor },
    },
    onOk() {
      onOk();
    },
    onCancel() {},
  });
};

export default ShowConfirmClose;
